import React, { DetailedHTMLProps, forwardRef, InputHTMLAttributes, ReactNode } from 'react';
import useRequiredId from 'hooks/useRequiredId';

import './SwitchInput.scss';

export interface CheckboxInputProps extends DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  label?: string | ReactNode;
  error?: string | ReactNode;
  touched?: boolean;
  fullWidth?: boolean;
}

const SwitchInput = forwardRef<HTMLInputElement, CheckboxInputProps>(({ id, error, touched, label, ...props }, ref) => {
  const ensuredId = useRequiredId(id);
  const errorId = `${ensuredId}-error`;

  const hasError = Boolean(error && error !== '' && touched);

  return (
    <div className="enkrateia-switch-input">
      <div>
        <label htmlFor={ensuredId}>
          <span className="switch">
            <input {...props} ref={ref} id={ensuredId} type="checkbox" />
            <span className="slider"></span>
          </span>
          <span className="label"> {label}</span>
        </label>
      </div>
      {hasError && (
        <span id={errorId} className="error-label">
          {error}
        </span>
      )}
    </div>
  );
});

export default SwitchInput;
